export {default} from './new-chat.vue'